import * as React from "react";
const SvgFiRrChartPyramid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chart-pyramid_svg__a)">
      <path
        fill="#062147"
        d="m23.413 18.24-7.82-15.965a4 4 0 0 0-7.185 0L.587 18.24A4 4 0 0 0 4.179 24h15.64a4 4 0 0 0 3.594-5.76M19.6 15H4.4l2.45-5h10.3zM10.2 3.155a2 2 0 0 1 3.592 0L16.169 8h-8.34zm11.314 17.9a1.96 1.96 0 0 1-1.7.942H4.179a2 2 0 0 1-1.8-2.88L3.42 17h17.157l1.038 2.12a1.96 1.96 0 0 1-.098 1.938z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-pyramid_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartPyramid;
